<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <v-card-title class="secondary--text font-weight-medium py-0">
          <v-row>
            <v-col cols="12" md="6" sm="6" lg="6">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t("customer.otp.otp") }}
              </h3>
            </v-col>
            <v-col class="text-end">
              <v-btn
                class="custom-button secondary text-none"
                to="/customer"
              >
                <v-icon size="20" left>
                  mdi-arrow-left-circle-outline
                </v-icon>
                {{ $t('common.back') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{'items-per-page-options':[50, 100, 150, 200, -1]}"
          :headers="headers"
          :items="otpLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalOtp"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0" >
              {{
                options.page * options.itemsPerPage - options.itemsPerPage
                +
                otpLists
                  .map(function(x) {
                    return x._id;
                  })
                  .indexOf(item._id) + 1
              }}
            </p>
          </template>
           <template v-slot:[`item.expiry`]="{ item }">
            <p>
              {{
                item.expiry
                ? dateFormat(new Date(parseInt(item.expiry)))
                  : "-"
              }}
            </p>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0,
      },
      options: {
        itemsPerPage: 50,
        page: 1,
      },
      otpLists: [],
      totalOtp: 10
    };
  },
  computed: {
    headers () {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          sortable: false,
          width: 10
        }, {
          text: this.$t("customer.otp.otp"),
          align: "left",
          value: "otp"
        }, {
          text: this.$t("customer.otp.phone"),
          align: "left",
          sortable: false,
          value: "phone"
        }, {
          text: this.$t("customer.otp.expiry"),
          align: "left",
          value: "expiry"
        }
      ]
    },
  },
  watch: {
    options () {
      this.$apollo.queries.getAllOpts.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totallandlord,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        }
      });
    }
  },
  apollo: {
    getAllOpts() {
      this.loading = true
      return {
        query: require("@/user/api/queries/customer/otp_query.graphql"),
        variables: {
          input: {
            limit: 50,
            skip: 0
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
         this.otpLists = this.$format.cloneVariable(data.getAllOtp.otps)
         this.totalOtp = data.getAllOtp.totalCount
         this.loading = loading
        },
      };
    },
  },
  methods: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY, h:mm:ss");
    },
    openRightSideDrawer () {
      this.$store.commit('SHOW_RIGHTSIDE_DRAWER', true)
    },
    showDeleteDialog (item) {
      this.$root.$emit('deleteDialog', { dialog: true, item: item })
    }
  }
};
</script>
<style scoped>
</style>
